import {Dialog} from "@headlessui/react"
import React from "react"
import Button from "../button/button";
import {ButtonStatus} from "../button/enum";
import CustomModal from "./customModal";
import Form from "../forms/form";

export interface AlertForm {
    title?: string,
    placeholder?: string,
    value?: string,
    invalidMsg?: string,
    onChange?: (text: string) => void
}

export interface AlertAction {
    title: string,
    disabled?: boolean,
    onClick: () => void
}

interface IProps {
    isOpen: boolean,
    title: string,
    description?: string,
    form?: AlertForm,
    rejectAction?: AlertAction
    resolveAction?: AlertAction
}

export default function Alert(props: IProps) {
    const {isOpen, title, description, form, rejectAction, resolveAction} = props

    const $description = description ? <p className="text-sm text-gray-500 my-2">{description}</p> : null

    const renderAlertButtons = () => {
        if (rejectAction || resolveAction) {
            return (
                <div className={"mt-4 border-t pt-4 flex flex-row justify-end items-center space-x-4"}>
                    {rejectAction ? <Button status={rejectAction.disabled ? ButtonStatus.disabled : ButtonStatus.light} onClick={rejectAction.onClick}>{rejectAction.title}</Button> : null}
                    {resolveAction ? <Button status={resolveAction.disabled ? ButtonStatus.disabled : ButtonStatus.primary} onClick={resolveAction.onClick}>{resolveAction.title}</Button> : null}
                </div>
            )
        }
        return null
    }

    const renderForm = () => {
        if (form) {
            let {title, placeholder, value, invalidMsg, onChange} = form
            return (
                <Form
                    title={title || ""}
                    placeholder={placeholder || ""}
                    errMsg={invalidMsg || ""}
                    value={value || ""}
                    onChangeText={(text) => {
                        onChange && onChange(text)
                    }}
                />
            )
        }
        return null
    }

    return (
        <CustomModal isOpen={isOpen}>
            <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
            >
                {title}
            </Dialog.Title>

            {$description}

            {renderForm()}

            {renderAlertButtons()}
        </CustomModal>
    )
}
